module.exports = __webpack_public_path__ + "static/media/iphone-mockup-sec3-1.2dc07313.png";